import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Box,
  Paper,
  List,
  ListItemButton,
  Stack,
  Typography,
  useMediaQuery,
  Divider,
  Avatar,
  IconButton,
  Tooltip,
  Modal,
  Toolbar,
  Button,
  Snackbar,
  CircularProgress,
  Slide,
  Checkbox,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../user-redux/selector";
import { myCandidatesSelector } from "../redux/selector";
import {
  getJobDetailsAction,
  getSolrJobsAction,
  getSolrJobsWithSubmissionAction,
  getSolrJobsCountAction,
  sendJobToCandidateAction,
  resetAction,
  selectedSubmissionAction,
} from "../redux/action";
import SendJobToCandidateEmail from "../CandidatesTabs/Submissions/emailTemplates/SendJobToCandidateEmail";
import Step1 from "../CandidatesTabs/Submissions/Step1";
import generateSolrQuery from "../../../helpers/solr";
import moment from "moment";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import {
  BusinessCenterRounded,
  EditRounded,
  EmailRounded,
  LaunchRounded,
} from "@mui/icons-material";
import MuiAlert from "@mui/material/Alert";
import generateSolrQueryCount from "../../../helpers/solr_job_count";
import { limit } from "../../utils/constantValues";
import { processSearchTitle } from "../../utils/utils";
import { jobsBuildFacetQuery } from "../../utils/jobsQueryBuilder";
import CandidateJobFilters from "../CandidateJobFilters";
import Pagination from '@mui/material/Pagination';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { validateReoonEmailVerification } from "../../../helpers/EmailFieldValidator";
import LoadingSkeleton from "../../loadingSkeletons/LoadingList";
import JobsSendToVendorModal from "./JobsSendToVendorModal";
import SendRoundedIcon from "@mui/icons-material/SendRounded";

const DEFAULT_ROW_COUNT = 20; // Set your default page size here

/** Company IDs allowed to multi-select jobs and bulk send to vendor from Jobs tab */
const BULK_JOB_SELECT_COMPANY_IDS = new Set([483370, 45721, 446766, 5425]);

const SlideTransition = React.forwardRef(function SlideTransition(props, ref) {
  return (
    <Slide
      direction="left"
      ref={ref}
      {...props}
      timeout={{
        enter: 500,
        exit: 400,
      }}
    />
  );
});

const Jobs = ({ refreshKey }) => {
  const {
    candidateDetails,
    candidateJobs,
    candidateJobsCount,
    jobDetails,
    keywords,
    searchCompanyName,
    searchLocation,
    searchTitle,
    searchExperience,
    candidateJobsLoading,
    candidateDetailLoading,
  } = useSelector(myCandidatesSelector);
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  const canBulkSelectJobs = BULK_JOB_SELECT_COMPANY_IDS.has(Number(user?.companyid));

  const [hasMore, setHasMore] = useState(true);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [sendJobFormOpen, setSendJobFormOpen] = useState(false);
  const [jobCount, setJobCount] = useState(0); // State to track job count
  const [page, setPage] = useState(1);
  const [interestedJobIds, setInteretedJobIds] = useState([]);
  const [notInterestedJobIds, setNotInteretedJobIds] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [toastSeverity, setToastSeverity] = useState("success");
  const [sendJobToCandidateEmailReview, setSendJobToCandidateEmailReview] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage, setJobsPerPage] = useState(10);
  const [isLoadingJobs, setIsLoadingJobs] = useState(false);
  const sendJobFormRef = useRef(null);
  const [selectedJobId, setSelectedJobId] = useState(candidateJobs?.[0]?.id); // Default to the first job ID
  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [sendToVendorOpen, setSendToVendorOpen] = useState(false);
  const [sendVendorResultDialog, setSendVendorResultDialog] = useState(null);
  const { activeCandidates } =
    useSelector(myCandidatesSelector);

  // Add ref to track if we're already fetching jobs
  const isFetchingRef = useRef(false);
  const debounceTimeoutRef = useRef(null);
  const skipPaginationFetchRef = useRef(false);
  const hasLoadedJobsListRef = useRef(false);

  const [emailData, setEmailData] = useState({
    candidateName: candidateDetails?.candidate_name || '',
    candidateid: candidateDetails?.candidate_id || '',
    toEmail: candidateDetails?.email || '',
    userid: user?.id || '',
    jobid: '',
    ccmail: [],
    subject: '',
    description: '',
    leadid: '',
    duration: '',
    emailBody: '',
    fromEmail: '',
    sgfromEmail: user?.username || '',
    companyid: user?.companyid || ''
  });
  const [formData, setFormData] = useState({
    candidateName: candidateDetails?.candidate_name || '',
    candidateid: candidateDetails?.candidate_id || '',
    toEmail: candidateDetails?.email || '',
    userid: user?.id || '',
    jobid: '',
    ccmail: [],
    subject: '',
    description: '',
    leadid: '',
    duration: '',
    emailBody: '',
    fromEmail: '',
    sgfromEmail: user?.username || '',
    companyid: user?.companyid || ''
  });

  // Initialize filters state
  const [selectedFilters, setSelectedFilters] = useState({
    postedDate: [],
    jobType: [],
    workType: [],
    employmentType: []
  });

  const handleDateFilter = (selectedDates) => {
    setSelectedFilters(prev => ({
      ...prev,
      postedDate: selectedDates
    }));
  };

  // useEffect(()=>{
  //   console.log("candidateJobsPageCount:", candidateJobsPageCount)
  // },[candidateJobsPageCount])

  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  const isDesktopLarge = useMediaQuery("(min-width: 1920px)");

  const containerStyles = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };

  function cleanSolrText(str) {
    if (!str) return "";
    return str
      .replace(/[–—]/g, '-') // convert EN/EM dash to regular hyphen
      .replace(/([+\-!(){}\[\]^"~*?:\\\/&|])/g, '\\$1') // escape Solr special chars instead of replacing with space
      .replace(/\s+/g, ' ') // normalize multiple spaces
      .trim(); // remove leading/trailing spaces
  }

  // Consolidated function to fetch jobs with debouncing
  const fetchJobs = useCallback(async (start = 0, rows = jobsPerPage, reset = false) => {
    if (isFetchingRef.current) return; // Prevent concurrent calls

    if (!candidateDetails?.candidate_id) return;

    // Clear any existing timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    setIsLoadingJobs(true);

    // Debounce the API call by 300ms
    debounceTimeoutRef.current = setTimeout(async () => {
      isFetchingRef.current = true;

      try {
        if (reset) {
          dispatch(resetAction());
          setCurrentPage(1);
        }

        const solrURL = getSolrQuery(start, rows);
        if (candidateDetails.candidate_id) {
          await dispatch(
            getSolrJobsWithSubmissionAction(
              solrURL,
              start,
              candidateDetails.candidate_id
            )
          );
        } else {
          await dispatch(getSolrJobsAction(solrURL, start));
        }
      } catch (error) {
        console.error('Error fetching jobs:', error);
      } finally {
        setIsLoadingJobs(false);
        isFetchingRef.current = false;
      }
    }, 300);
  }, [
    candidateDetails,
    selectedFilters,
    searchCompanyName,
    searchTitle,
    searchLocation,
    searchExperience,
    jobsPerPage,
    dispatch,
  ]);

  // Single optimized useEffect for fetching jobs
  useEffect(() => {
    // Always refetch when refreshKey changes (even for same candidate)
    if (candidateDetails?.candidate_id) {
      skipPaginationFetchRef.current = true;
      setIsLoadingJobs(true);
      setCurrentPage(1);
      fetchJobs(0, jobsPerPage, true);
    } else {
      dispatch(resetAction());
    }
  }, [
    candidateDetails?.candidate_id,
    selectedFilters,
    searchCompanyName,
    searchLocation,
    searchTitle,
    searchExperience,
    fetchJobs,
    refreshKey,
    dispatch
  ]);

  // UseEffect for pagination and page size changes
  useEffect(() => {
    if (!candidateDetails?.candidate_id) return;
    if (skipPaginationFetchRef.current) {
      skipPaginationFetchRef.current = false;
      return;
    }
    const start = (currentPage - 1) * jobsPerPage;
    fetchJobs(start, jobsPerPage, false);
  }, [currentPage, jobsPerPage, candidateDetails?.candidate_id, fetchJobs]);

  // Cleanup timeout on unmount or dependency changes
  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);


  // useEffect(() => {
  //   console.log("searchLocation", {
  //     searchCompanyName,
  //     searchLocation,
  //     searchTitle,
  //   })
  // }, [searchLocation])

  useEffect(() => {
    if (candidateJobs?.length > 0) {
      setSelectedJobId(candidateJobs[0].id);
    }
  }, [candidateJobs, candidateDetails]);

  useEffect(() => {
    setSelectedJobIds([]);
  }, [candidateDetails?.candidate_id, currentPage, jobsPerPage]);

  useEffect(() => {
    if (!canBulkSelectJobs) {
      setSelectedJobIds([]);
      return;
    }
    setSelectedJobIds((prev) =>
      prev.filter((id) => {
        const job = candidateJobs?.find((j) => String(j.id) === id);
        return job && Number(job.insubmission) !== 1;
      })
    );
  }, [candidateJobs, canBulkSelectJobs]);

  useEffect(() => {
    const pendingIds = sessionStorage.getItem("jobs_bulk_selected_ids");
    const fromZoho = sessionStorage.getItem("zoho_redirect_jobs");
    if (fromZoho && pendingIds && candidateDetails?.candidate_id) {
      try {
        const ids = JSON.parse(pendingIds).map(String);
        if (ids.length > 0) {
          setSelectedJobIds(ids);
          setSendToVendorOpen(true);
        }
      } catch (e) {
        console.error("Failed to restore bulk job selection", e);
      }
      sessionStorage.removeItem("zoho_redirect_jobs");
    }
  }, [candidateDetails?.candidate_id]);

  // Update getSolrQuery to accept start and rows for pagination
  const getSolrQuery = (start = 0, rows = DEFAULT_ROW_COUNT) => {
    // Process date filters — use the widest selected range
    // (last-7-days > last-3-days > today). Nested if/else that checked
    // "today" first ignored broader selections when both were active.
    let dateFilter = null;
    if (selectedFilters.postedDate.length > 0) {
      const now = moment();
      const endOfToday = now.clone().endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');

      if (selectedFilters.postedDate.includes('last-7-days')) {
        const sevenDaysAgoStart = now.clone().subtract(6, 'days').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        dateFilter = `posted_date:[${sevenDaysAgoStart} TO ${endOfToday}]`;
      } else if (selectedFilters.postedDate.includes('last-3-days')) {
        const threeDaysAgoStart = now.clone().subtract(2, 'days').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        dateFilter = `posted_date:[${threeDaysAgoStart} TO ${endOfToday}]`;
      } else if (selectedFilters.postedDate.includes('today')) {
        const startOfDay = now.clone().startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
        dateFilter = `posted_date:[${startOfDay} TO ${endOfToday}]`;
      }
    }

    // Process job type and work type filters
    let jobType = null;
    if (selectedFilters.jobType?.length) {
      jobType = '(' + selectedFilters.jobType
        .map(t => `jobtype_name:*${escapeForLucene(t)}*`)
        .join(' OR ') + ')';
    }

    let workType = null;
    if (selectedFilters.workType.length > 0) {
      workType = selectedFilters.workType.map(type => `remote:${type === 'remote' ? 1 : 0}`).join(" OR ");
    }

    // API experience values are free-form: "", "0", "2+ years", "4-7 years", "5+ years", "6+ years"
    let experienceFilter = null;
    if (searchExperience && searchExperience.trim() !== "") {
      const buildExperienceValues = (values) =>
        values.map((v) => `"${v}"`).join(" OR ");

      const experienceSolrMap = {
        "0-3": buildExperienceValues([
          "0",
          "1+ years", "2+ years", "3+ years",
          "1+ Years", "2+ Years", "3+ Years",
          "0-1 years", "0-2 years", "0-3 years",
          "1-2 years", "1-3 years", "2-3 years",
          "0-1 Years", "0-2 Years", "0-3 Years",
          "1-2 Years", "1-3 Years", "2-3 Years",
          "1 year", "2 years", "3 years",
          "1 Year", "2 Years", "3 Years",
        ]),
        "4-7": buildExperienceValues([
          "4+ years", "5+ years", "6+ years", "7+ years",
          "4+ Years", "5+ Years", "6+ Years", "7+ Years",
          "4-5 years", "4-6 years", "4-7 years",
          "5-6 years", "5-7 years", "6-7 years",
          "4-5 Years", "4-6 Years", "4-7 Years",
          "5-6 Years", "5-7 Years", "6-7 Years",
          "4 years", "5 years", "6 years", "7 years",
          "4 Years", "5 Years", "6 Years", "7 Years",
        ]),
        "8-10": buildExperienceValues([
          "8+ years", "9+ years", "10+ years",
          "8+ Years", "9+ Years", "10+ Years",
          "8-9 years", "8-10 years", "9-10 years",
          "8-9 Years", "8-10 Years", "9-10 Years",
          "8 years", "9 years", "10 years",
          "8 Years", "9 Years", "10 Years",
        ]),
        "10+": buildExperienceValues([
          "10+ years", "11+ years", "12+ years", "15+ years",
          "10+ Years", "11+ Years", "12+ Years", "15+ Years",
          "10-12 years", "10-15 years", "12-15 years",
          "10-12 Years", "10-15 Years", "12-15 Years",
          "above 10 Years", "Above 10 Years", "above 10 years",
        ]),
      };

      const experienceValues = experienceSolrMap[searchExperience];
      if (experienceValues) {
        experienceFilter = `experience:(${experienceValues})`;
      }
    }

    let exactTitles = [];

    // **FIXED: Check if searchTitle exists first**
    if (searchTitle && searchTitle.trim() !== "") {
      // If there's a search title, use ONLY that
      exactTitles.push(searchTitle);
    } else {
      // Only use related titles and role if no search title
      if (candidateDetails?.related_titles) {
        exactTitles = exactTitles.concat(candidateDetails.related_titles.split(","));
      }

      if (candidateDetails?.role) {
        exactTitles.push(candidateDetails.role);
      }
    }

    function escapeForLucene(value) {
      let v = value.replace(/\\/g, '\\\\');
      v = v.replace(/([+\-!(){}\[\]^"~?:/])/g, '\\$1');
      v = v.replace(/ /g, '\\ ');
      return v;
    }

    const sanitizeAndEncode = (text) =>
      encodeURIComponent(
        text.replace(/[&+!(){}[\]^"~*?:\\\/|]/g, "").trim()
      )

    const cleanedTitles = exactTitles
      .filter(Boolean)
      .map(title => `"${sanitizeAndEncode(title.trim())}"`);

    const searchParams = {
      title: cleanedTitles.join(" OR "),
      location: searchLocation || null,
      company_name: searchCompanyName || null,
      filter_query: [
        dateFilter,
        jobType ? `(${jobType})` : null,
        workType ? `(${workType})` : null,
        experienceFilter,
      ].filter(Boolean)
    };


    const generatedSolrQuery = jobsBuildFacetQuery({}, searchParams, {
      start: start,
      rows: rows
    });

    return generatedSolrQuery;
  };

  const onClickJob = (job) => {
    if (!job?.id) return;
    if (
      String(job.id) === String(jobDetails?.id) &&
      Object.keys(jobDetails || {}).length > 0
    ) {
      return;
    }
    dispatch(getJobDetailsAction(job.id));
  };

  const handleJobSelect = (jobId) => {
    setSelectedJobId(jobId);
  };

  const isJobInSubmission = (job) =>
    Number(job?.insubmission) === 1;

  const toggleJobSelection = (job, event) => {
    event?.stopPropagation();
    if (isJobInSubmission(job)) return;
    const id = String(job.id);
    setSelectedJobIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleOpenSendToVendor = () => {
    if (!canBulkSelectJobs) return;
    if (!selectedJobIds.length) {
      setOpenToast(true);
      setToastSeverity("warning");
      setToastMessage("Select at least one job to send.");
      setTimeout(() => setOpenToast(false), 2000);
      return;
    }
    if (!candidateDetails?.candidate_id) {
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("Missing candidate information.");
      setTimeout(() => setOpenToast(false), 2000);
      return;
    }
    setSendToVendorOpen(true);
  };

  const handleSendToVendorClose = (result) => {
    setSendToVendorOpen(false);
    if (!result?.success || !result?.summary) return;

    const {
      sentCount = 0,
      updatedCount = 0,
      notUpdatedCount = 0,
      alreadySubmittedJobs = [],
      skippedJobs = [],
      alreadySubmittedJobIds = [],
      skippedJobIds = [],
    } = result.summary;

    const mailSent = updatedCount || sentCount;

    const normalizeNotSentJobs = (jobs, jobIds) => {
      if (jobs?.length) return jobs;
      return (jobIds || []).map((id) => ({
        jobid: String(id),
        jobtitle: "N/A",
        company_name: "N/A",
      }));
    };

    setSelectedJobIds([]);
    sessionStorage.removeItem("jobs_bulk_selected_ids");
    sessionStorage.removeItem("target_job_id");
    dispatch(selectedSubmissionAction(null));
    setSendVendorResultDialog({
      mailSent,
      notUpdated: notUpdatedCount,
      alreadySubmittedJobs: normalizeNotSentJobs(
        alreadySubmittedJobs,
        alreadySubmittedJobIds
      ),
      skippedJobs: normalizeNotSentJobs(skippedJobs, skippedJobIds),
    });

    if (candidateDetails?.candidate_id) {
      fetchJobs((currentPage - 1) * jobsPerPage, jobsPerPage, false);
    }

    setOpenToast(true);
    setToastSeverity(mailSent > 0 ? "success" : "warning");
    setToastMessage(
      `Updated: ${mailSent} job(s). Not updated: ${notUpdatedCount} job(s).`
    );
    setTimeout(() => setOpenToast(false), 4000);
  };

  const selectedJobsForSend = (candidateJobs || []).filter((job) =>
    selectedJobIds.includes(String(job.id))
  );

  const handleSuccessToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };

  const emailDataHandler = (data) => {
    setEmailData(data);
  };

  const isSubmitHandler = (data) => {
    if (data === "success") {
      setSendJobFormOpen(false);
      setOpenToast(true);
      setToastSeverity("success");
      setToastMessage("Job Sent successfully!");
      if (jobDetails?.id) {
        sessionStorage.setItem("target_job_id", jobDetails.id);
      }
      setTimeout(() => {
        setOpenToast(false);
      }, 2000);
    } else if (data === "cancel") {
      setSendJobFormOpen(false);
      setOpenToast(true);
      setToastSeverity("warning");
      setToastMessage("Job Sent Cancel!");
      setTimeout(() => {
        setOpenToast(false);
      }, 2000);
    } else if (data === "exist") {
      setSendJobFormOpen(false);
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("Job already sent by teammate!");
    } else if (data === "error") {
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("Something went wrong!");
      window.location.reload();
    }
  };

  const handleNext = () => {
    setSendJobFormOpen(false);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);

    if (!candidateDetails?.candidate_id || !jobDetails?.id) {
      isSubmitHandler("error");
      setIsSubmitting(false);
      return;
    }

    let updatedData = {
      candidateid: (emailData?.candidateid || formData?.candidateid),
      jobid: (emailData?.jobid || formData?.jobid),
      userid: (emailData?.userid || formData?.userid),
      status: "1",
    };

    // If any required field is missing, show error
    if (!updatedData.candidateid || !updatedData.jobid || !updatedData.userid) {
      isSubmitHandler("error");
      setIsSubmitting(false);
      return;
    }

    const finalData = emailData || formData;

    try {
      const response = await validateReoonEmailVerification(finalData.toEmail);
      if (!response.valid) {
        isSubmitHandler("error");
        setIsSubmitting(false);
        setOpenToast(true);
        setToastSeverity("error");
        setToastMessage(response.message || "Invalid email address");
        setTimeout(() => {
          setOpenToast(false);
        }, 2000);
        console.error("Email validation failed:", response.message);
        return;
      }
    } catch (error) {
      console.error("Email validation error:", error);
      isSubmitHandler("error");
      setIsSubmitting(false);
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("Error validating email. Please try again.");
      setTimeout(() => {
        setOpenToast(false);
      }, 2000);
      console.error("Email validation error:", error);
      return;
    }

    try {
      const response = await dispatch(
        sendJobToCandidateAction(
          finalData,
          updatedData,
          user?.id,
          candidateDetails?.candidate_id,
          jobDetails?.id
        )
      );
      if (response?.data === "Job already submitted to candidate already") {
        isSubmitHandler("exist");
      } else if (response?.data?.affectedRows > 0) {
        isSubmitHandler("success");
      } else {
        isSubmitHandler("error");
      }
    } catch (error) {
      console.error(error);
      isSubmitHandler("error");
    }
    setIsSubmitting(false);
  };

  // Calculate total pages
  const totalPages = Math.ceil(candidateJobsCount / jobsPerPage);

  // Use backend-paginated jobs directly
  const paginatedJobs = candidateJobs || [];
  const selectablePageJobIds = paginatedJobs
    .filter((job) => !isJobInSubmission(job))
    .map((job) => String(job.id));
  const allSelectablePageJobsSelected =
    selectablePageJobIds.length > 0 &&
    selectablePageJobIds.every((id) => selectedJobIds.includes(id));
  const handleSelectAllOnPage = (event) => {
    event.stopPropagation();
    if (allSelectablePageJobsSelected) {
      setSelectedJobIds((prev) =>
        prev.filter((id) => !selectablePageJobIds.includes(id))
      );
    } else {
      setSelectedJobIds((prev) => [
        ...new Set([...prev, ...selectablePageJobIds]),
      ]);
    }
  };

  const handlePageChange = (event, newPage) => {
    if (newPage === currentPage) return; // Prevent unnecessary calls
    setCurrentPage(newPage);
  };

  const handleJobsPerPageChange = async (event) => {
    const newJobsPerPage = Number(event.target.value);
    setJobsPerPage(newJobsPerPage);
    setCurrentPage(1); // Reset to first page when changing page size
    // Fetch jobs for the first page with new page size
    if (candidateDetails) {
      await fetchJobs(0, newJobsPerPage, true);
    }
  };

  // Update form data when job details change
  useEffect(() => {
    if (jobDetails) {
      setEmailData(prevData => ({
        ...prevData,
        jobid: jobDetails?.id || '',
        subject: jobDetails?.jobtitle || '',
        description: jobDetails?.job_description || '',
        fromEmail: jobDetails?.email_id || ''
      }));

      setFormData(prevData => ({
        ...prevData,
        jobid: jobDetails?.id || '',
        subject: jobDetails?.jobtitle || '',
        description: jobDetails?.job_description || '',
        fromEmail: jobDetails?.email_id || ''
      }));
    }
  }, [jobDetails]);

  // Update form data when candidate details change 
  useEffect(() => {
    if (candidateDetails) {
      setEmailData(prevData => ({
        ...prevData,
        candidateName: candidateDetails?.candidate_name || '',
        candidateid: candidateDetails?.candidate_id || '',
        toEmail: candidateDetails?.email || ''
      }));

      setFormData(prevData => ({
        ...prevData,
        candidateName: candidateDetails?.candidate_name || '',
        candidateid: candidateDetails?.candidate_id || '',
        toEmail: candidateDetails?.email || ''
      }));
    }
  }, [candidateDetails]);

  // Update user related fields when user changes
  useEffect(() => {
    if (user) {
      setEmailData(prevData => ({
        ...prevData,
        userid: user?.id || '',
        sgfromEmail: user?.username || '',
        companyid: user?.companyid || ''
      }));

      setFormData(prevData => ({
        ...prevData,
        userid: user?.id || '',
        sgfromEmail: user?.username || '',
        companyid: user?.companyid || ''
      }));
    }
  }, [user]);

  const closeModal = () => {
    setSendJobFormOpen(false);
    setSendJobToCandidateEmailReview(false);
    isSubmitHandler("cancel");
  };

  const handleSendJobToCandidate = (job) => {
    if (isJobInSubmission(job)) {
      setOpenToast(true);
      setToastSeverity("warning");
      setToastMessage("This job is already in submission.");
      setTimeout(() => setOpenToast(false), 2500);
      return;
    }

    if (job?.id) {
      dispatch(getJobDetailsAction(job.id));
      handleJobSelect(job.id);
    }

    setTimeout(() => {
      const jobId = job?.id || jobDetails?.id;
      if (!candidateDetails?.candidate_id || !jobId) {
        setOpenToast(true);
        setToastSeverity("error");
        setToastMessage("Missing required job or candidate information");
        setTimeout(() => setOpenToast(false), 2000);
        return;
      }
      setSendJobFormOpen(true);
    }, 2000);
  };

  const toggleEmailReview = (showReview) => {
    // Add validation before toggling email review
    if (!emailData && !formData) {
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("No email data available to review");
      return;
    }
    setSendJobToCandidateEmailReview(showReview);
  };

  const updateJobCount = (count) => {
    setJobCount(count);
  };

  const loading = candidateJobsLoading || isLoadingJobs || candidateDetailLoading;

  // Like ActiveCandidates: skeleton only on first load; keep pagination visible after that
  useEffect(() => {
    if (!loading) {
      hasLoadedJobsListRef.current = true;
    }
  }, [loading]);

  useEffect(() => {
    hasLoadedJobsListRef.current = false;
  }, [candidateDetails?.candidate_id]);

  const showInitialJobsLoading = loading && !hasLoadedJobsListRef.current;
  const hasJobSelection = canBulkSelectJobs && selectedJobIds.length > 0;

  const getAvatarSize = () =>
    isDesktopLarge || isDesktopMedium
      ? 32
      : isDesktopSmall
        ? 26
        : 24;

  const avatarPx = getAvatarSize();
  const iconPx = isDesktopLarge || isDesktopMedium ? 24 : isDesktopSmall ? 16 : 14;

  return (
    <Box sx={containerStyles}>
      {hasJobSelection ? (
        <Box
          sx={{
            p: 1,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={0.5}
            sx={{ width: "100%", minWidth: 0 }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={0}
              sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}
            >
              <Checkbox
                size="small"
                checked={allSelectablePageJobsSelected}
                indeterminate={false}
                disabled={selectablePageJobIds.length === 0}
                onChange={handleSelectAllOnPage}
                sx={{ p: 0.5, flexShrink: 0 }}
              />
              <Typography
                variant="caption"
                noWrap
                sx={{ fontWeight: 600, color: "#406882", fontSize: "12px" }}
              >
                Select all
              </Typography>
              <Typography
                variant="caption"
                noWrap
                sx={{ color: "#757575", fontSize: "11px", ml: 0.5 }}
              >
                ({selectedJobIds.length})
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{ flexShrink: 0 }}
            >
              <Button
                size="small"
                sx={{
                  textTransform: "none",
                  color: "#616161",
                  fontSize: "11px",
                  minWidth: "auto",
                  px: 1,
                }}
                onClick={() => setSelectedJobIds([])}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={handleOpenSendToVendor}
                sx={{
                  textTransform: "none",
                  fontSize: "11px",
                  whiteSpace: "nowrap",
                  minWidth: "auto",
                  px: 1.25,
                  py: 0.5,
                  backgroundImage:
                    "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
                }}
              >
                <SendRoundedIcon sx={{ fontSize: 14, mr: 0.5 }} />
                Send
              </Button>
            </Stack>
          </Stack>
        </Box>
      ) : (
        <CandidateJobFilters
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      )}
      <Divider />
      {loading ? (
        <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
          {Array.from({ length: 8 }).map((_, i) => (
            <LoadingSkeleton key={i} />
          ))}
        </Box>
      ) : (
        <>
          {!loading && candidateJobs.length === 0 && candidateJobsCount > 0 ? (
            <Typography
              variant="h6"
              align="center"
              sx={{ margin: 2, fontSize: "15px" }}
            >
              No jobs found
              for this page.
            </Typography>
          ) : (
            <List sx={{ flex: 1, overflowY: "auto", p: 0 }}>
              {/* {console.log("paginatedJobspaginatedJobs",candidateJobs)} */}
              {paginatedJobs.map((job, i) => {
                const inSubmission = isJobInSubmission(job);
                return (
                  <ListItemButton
                    key={job.id ?? i}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      minWidth: 0,
                      opacity: inSubmission ? 0.72 : 1,
                      backgroundColor: selectedJobIds.includes(String(job.id))
                        ? "#e8f4fc"
                        : selectedJobId === job.id
                          ? "#f0f8ff"
                          : "inherit",
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                    onClick={() => {
                      onClickJob(job); // Existing functionality
                      handleJobSelect(job.id); // Update selected job
                    }}
                    onMouseEnter={() => setHoveredItem(job.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1.25,
                        alignItems: "center",
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          width: avatarPx,
                          height: avatarPx,
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {canBulkSelectJobs &&
                          !inSubmission &&
                          (hoveredItem === job.id ||
                            selectedJobIds.includes(String(job.id))) ? (
                          <Checkbox
                            size="small"
                            checked={selectedJobIds.includes(String(job.id))}
                            onChange={(e) => toggleJobSelection(job, e)}
                            onClick={(e) => e.stopPropagation()}
                            sx={{ p: 0 }}
                          />
                        ) : (
                          <Avatar
                            sx={{
                              height: avatarPx,
                              width: avatarPx,
                              bgcolor: "#406882",
                            }}
                          >
                            <BusinessCenterRounded
                              sx={{
                                color: "#fff",
                                height: iconPx,
                                width: iconPx,
                              }}
                            />
                          </Avatar>
                        )}
                      </Box>
                      <Stack direction="column" sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          title={job.jobtitle}
                          noWrap
                          sx={{
                            fontSize: isDesktopXS ? "10px" : "12px",
                            fontWeight: 600,
                            margin: 0,
                          }}
                        >
                          {job.jobtitle}
                        </Typography>
                        <Typography
                          title={job?.company_name}
                          noWrap
                          sx={{
                            fontSize: isDesktopXS ? "9px" : "11px",
                          }}
                        >
                          {job?.company_name || "N/A"}
                        </Typography>
                        <Typography
                          title={job?.location}
                          noWrap
                          sx={{ fontSize: isDesktopXS ? "9px" : "11px" }}
                        >
                          {job?.location?.replace(",", ", ") || "Remote"}
                        </Typography>
                      </Stack>
                    </Box>
                    <Stack
                      direction="column"
                      alignItems="flex-end"
                      sx={{ flexShrink: 0, ml: 0.5 }}
                    >
                      {inSubmission && (
                        <Chip
                          label="In submission"
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "9px",
                            mb: 0.25,
                            bgcolor: "#e8eaf6",
                            color: "#3949ab",
                          }}
                        />
                      )}
                      <Tooltip
                        title={
                          inSubmission
                            ? "Already in submission"
                            : "Send Job to Candidate"
                        }
                      >
                        <span>
                          <IconButton
                            sx={{ padding: 0 }}
                            disabled={inSubmission}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!inSubmission) handleSendJobToCandidate(job);
                            }}
                            aria-label="Send Job to Candidate"
                          >
                            <LaunchRounded style={{ fontSize: "15px" }} />
                          </IconButton>
                        </span>
                      </Tooltip>
                      {interestedJobIds?.includes(parseInt(job?.id)) && (
                        <Tooltip title="Interested" arrow placement="top">
                          <IconButton color="primary" size="small">
                            <ThumbUpIcon style={{ fontSize: "14px" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      {notInterestedJobIds?.includes(parseInt(job?.id)) && (
                        <Tooltip title="Not Interested" arrow placement="top">
                          <IconButton color="warning" size="small">
                            <ThumbDownAltOutlinedIcon
                              style={{ fontSize: "14px" }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Typography
                        sx={{
                          fontSize: isDesktopXS ? "8px" : "10px",
                          color: "#757575",
                        }}
                      >
                        {moment(job.posted_date).fromNow()}
                      </Typography>
                    </Stack>
                  </ListItemButton>
                );
              })}
            </List>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              p: 1,
              borderTop: "1px solid rgba(0, 0, 0, 0.12)",
              bgcolor: "#fff",
            }}
          >
            <Pagination
              count={totalPages || 1}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              size="small"
              sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}
              siblingCount={0}
              boundaryCount={1}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', px: 2 }}>
              <Typography variant="body2" sx={{ mr: 1 }}>Rows per page:</Typography>
              <Select
                size="small"
                variant="standard"
                value={jobsPerPage}
                onChange={handleJobsPerPageChange}
                sx={{ width: 60 }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </Box>
          </Box>
        </>
      )}
      <Modal
        open={sendJobFormOpen}
        onClose={closeModal}
        closeAfterTransition
        TransitionComponent={SlideTransition}
        BackdropProps={{
          timeout: 500,
          onClick: closeModal,
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiPaper-root': {
            opacity: 1,
            transform: 'none'
          }
        }}
      >
        <Paper
          elevation={4}
          sx={{
            position: 'relative',
            margin: 'auto',
            width: '50%',
            maxHeight: '80vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 3,

            borderRadius: 2,
            overflowY: 'auto',
            transition: theme => theme.transitions.create(['transform', 'opacity'], {
              duration: theme.transitions.duration.standard,
            })
          }}
        >
          <Toolbar sx={{ minHeight: "48px !important" }}>
            <Typography paragraph sx={{ m: 0, fontWeight: 600 }}>
              Send Job To Candidate
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Tooltip title="Email Review" arrow placement="top">
              <IconButton
                sx={{
                  backgroundImage: sendJobToCandidateEmailReview
                    ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
                    : null,
                  height: "30px",
                  width: "30px",
                  mr: "5px",
                  border: !sendJobToCandidateEmailReview
                    ? "1px solid #ddd"
                    : "none",
                }} onClick={() => toggleEmailReview(true)}
              >
                <EmailRounded
                  sx={{
                    color: sendJobToCandidateEmailReview
                      ? "#fff"
                      : null,
                    height: "18px",
                    width: "18px",
                  }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Email" arrow placement="top">
              <IconButton
                sx={{
                  backgroundImage: !sendJobToCandidateEmailReview
                    ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
                    : null,
                  height: "30px",
                  width: "30px",
                  border: sendJobToCandidateEmailReview
                    ? "1px solid #ddd"
                    : "none",
                }} onClick={() => toggleEmailReview(false)}
              >
                <EditRounded
                  sx={{
                    color: !sendJobToCandidateEmailReview
                      ? "#fff"
                      : null,
                    height: "18px",
                    width: "18px",
                  }}
                />
              </IconButton>
            </Tooltip>
            <Button
              variant="contained"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
                ml: "5px",
                backgroundImage:
                  "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
              }}
              onClick={handleSubmit}
            >
              {isSubmitting ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Send Email"
              )}
            </Button>
          </Toolbar>
          <Divider />
          {sendJobToCandidateEmailReview ? (
            <SendJobToCandidateEmail
              isSubmitHandler={isSubmitHandler}
              emailData={emailData !== null ? emailData : formData}
            />
          ) : (
            <Step1
              handleNext={handleNext}
              emailDataHandler={emailDataHandler}
            />
          )}
        </Paper>
      </Modal>

      {canBulkSelectJobs && (
        <JobsSendToVendorModal
          open={sendToVendorOpen}
          onClose={handleSendToVendorClose}
          selectedJobIds={selectedJobIds}
          selectedJobs={selectedJobsForSend}
        />
      )}

      <Dialog
        open={Boolean(sendVendorResultDialog)}
        onClose={() => setSendVendorResultDialog(null)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, pb: 1 }}>
          Send to vendor — summary
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            <strong>Mail sent / updated:</strong>{" "}
            {sendVendorResultDialog?.mailSent ?? 0} job(s)
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            <strong>Not updated:</strong>{" "}
            {sendVendorResultDialog?.notUpdated ?? 0} job(s)
          </Typography>
          {sendVendorResultDialog?.alreadySubmittedJobs?.length > 0 && (
            <Box sx={{ mb: 1.5 }}>
              <Typography variant="caption" color="text.secondary" display="block">
                Already in submission (skipped):
              </Typography>
              {sendVendorResultDialog.alreadySubmittedJobs.map((job) => (
                <Typography key={job.jobid} variant="body2" sx={{ mt: 0.5 }}>
                  {job.jobtitle} — {job.company_name}
                </Typography>
              ))}
            </Box>
          )}
          {sendVendorResultDialog?.skippedJobs?.length > 0 && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Could not process (missing vendor email or job):
              </Typography>
              {sendVendorResultDialog.skippedJobs.map((job) => (
                <Typography key={job.jobid} variant="body2" sx={{ mt: 0.5 }}>
                  {job.jobtitle} — {job.company_name}
                </Typography>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSendVendorResultDialog(null)}
            variant="contained"
            size="small"
            sx={{ textTransform: "capitalize" }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openToast}
        autoHideDuration={6000}
        onClose={handleSuccessToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleSuccessToastClose}
          severity={toastSeverity}
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>

    </Box>
  );
};

export default Jobs;
// Styles are now handled inline in the Paper component using MUI's sx prop